/**
 * enhancedConversionTracker: The objective of this module is to update the global object ecData
 * and push to dataLayer.
 *
 * The reason of this change is related to the implmentation of Enhanced Conversion in Google Ads.
 * Read more at: https://support.google.com/google-ads/answer/9888656?hl=en-GB.
 * ecData is a variable in the dataLayer that have the user attributes when lead is requested, and via
 * GTM we get that data to send to Google Ads.
 *
 * Use identityTracker to update this object.
 */
(function enhancedConversionTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};
  const previousModule = global.NewHomeSource.Analytics.EnhancedConversionTracker;
  global.ecData = global.ecData || {};

  /**
   * @constructs NewHomeSource.Analytics.EnhancedConversionTracker
   */
  function EnhancedConversionTracker() {
  }

  /**
   * @public
   * identityTracker: send data related to user identification events.
   *
   */
  EnhancedConversionTracker.identityTracker = function identityTracker() {
    const identityData = this.form.querySelectorAll('[data-ec-identity-data]');
    identityData.forEach((element) => {
      if (element.dataset.ecIdentityData) {
        global.ecData[element.dataset.ecIdentityData] = element.value;
      }
    });

    window.dataLayer.push({
      event: 'formSubmitted',
      ecData: global.ecData
    });

    return true;
  };

  /**
   * @public
   * identityTrackerValidator: validates if the dataset passed as parameter represents a being tracked.
   */
  EnhancedConversionTracker.identityTrackerValidator = function identityTrackerValidator(dataset) {
    return !!dataset.ecIdentity;
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Analytics.EnhancedConversionTracker to the previous script.
   */
  EnhancedConversionTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.EnhancedConversionTracker = previousModule;
    return EnhancedConversionTracker;
  };

  global.NewHomeSource.Analytics.EnhancedConversionTracker = EnhancedConversionTracker;

  return EnhancedConversionTracker;
}(window));
